import { Injectable } from '@angular/core';
import { CtlBysSurecService } from '../ctl-bys-surec.service';
import { DataCoreService } from '../../../../services/data-core.service';

@Injectable({
  providedIn: 'root'
})
export class CtlBysSurecAramaService {

  constructor(private dataCoreService: DataCoreService, private service: CtlBysSurecService) {}

  getData(control: any) {
          const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
          dataSource.select([]);
          
          const filterArr = [];
          if(this.service.birim) filterArr.push(['BirimKod', '=', this.service.birim]);
          dataSource.filter(filterArr)
          return dataSource;
  }}
